import React from "react";
import SiteVisit from "../../dashboard/CRM/SiteVisit";
import {Grid} from '@material-ui/core'
import moment from 'moment-timezone'
// import NotyBot from './img/notybotWelcome.png'
import {isNull} from 'lodash'
import { injectIntl } from 'react-intl';
import { useSelector } from "react-redux";

const WelComeBanner = (props) => {
  const Flags = useSelector(state => state.accountsData.Flags)

  const returnWelcomeMessage = () => {
    var now = new Date().getHours()

    console.log(now)

    if(5 <= now && now <= 9) return `${props.intl.formatMessage({ id: 'Massage.Good.Morning' })} ` + props.WelcomedUser +'!'
    if(10 <= now && now <= 11) return `${props.intl.formatMessage({ id: 'Massage.Good.Morning1' })} `+ props.WelcomedUser +'!'
    if(12 <= now && now <= 15) return `${props.intl.formatMessage({ id: 'Massage.Good.day' })} `+ props.WelcomedUser +'!'
    if(16 <= now && now <= 18) return `${props.intl.formatMessage({ id: 'Massage.Good.afternoon' })} `+ props.WelcomedUser +'!'
    if((19 <= now && now <= 23) || (0 <= now && now <= 4)) return `${props.intl.formatMessage({ id: 'Massage.Good.night' })} `+ props.WelcomedUser +'!'
    else return ''
  }

  return (
    <div className="d-flex align-items-center justify-content-between text-white h-100 px-2">
        <div style={{width: 1}}>
            {
                isNull(Flags.KontoLogo) ? '' : 
                <img  src={Flags.KontoLogo} alt="" style={{ objectFit: 'contain', maxHeight: 50, height: '100%'}} />
            }
        </div>
        <div>
            <h3 className="mb-0 text-center" style={{fontSize:22}}>{returnWelcomeMessage()}</h3>
        </div>
        <div style={{width: 1}}></div>
    </div>
  );

};

export default injectIntl(WelComeBanner);
